import { useEffect, useState } from "react";
import api from "../api";

/**
 * Banner de trazabilidad visible solo para staff/superuser.
 * Muestra: bundle: RUTA_BUNDLE | backend: VERSION_BACKEND
 */
export default function AdminBanner() {
  const [show, setShow] = useState(false);
  const [bundle, setBundle] = useState("");
  const [backend, setBackend] = useState("…");

  useEffect(() => {
    // Detectar bundle activo desde los <script> cargados en el DOM
    const detectBundle = () => {
      const scripts = Array.from(document.querySelectorAll("script[src]"));
      const entry = scripts.find((s) => /\/assets\/index-[^/]+\.js/.test(s.src));
      if (entry) {
        try {
          // Devolver solo la parte /assets/... para no exponer el host
          const url = new URL(entry.src);
          setBundle(url.pathname + (url.search || ""));
        } catch {
          setBundle(entry.src);
        }
      }
    };

    // Verificar si es admin y traer versión backend
    api
      .get("me/")
      .then((res) => {
        const d = res?.data || {};
        if (d.is_staff || d.is_superuser) {
          setShow(true);
          detectBundle();
          api
            .get("build-info/")
            .then((r) => setBackend(r?.data?.backend || "unknown"))
            .catch(() => setBackend("error"));
        }
      })
      .catch(() => {});
  }, []);

  if (!show) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 99999,
        background: "#1a1a2e",
        color: "#a8ff78",
        fontFamily: "monospace",
        fontSize: "11px",
        padding: "3px 12px",
        borderTop: "1px solid #333",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        userSelect: "text",
        opacity: 0.92,
      }}
      title="Panel de trazabilidad – solo visible para administradores"
    >
      <span style={{ opacity: 0.5 }}>⚙ </span>
      <span>
        <span style={{ color: "#78d6ff" }}>bundle:</span>{" "}
        <span style={{ color: "#ffe87c" }}>{bundle || "detectando…"}</span>
        {"  "}
        <span style={{ color: "#aaa" }}>|</span>
        {"  "}
        <span style={{ color: "#78d6ff" }}>backend:</span>{" "}
        <span style={{ color: "#ffe87c" }}>{backend}</span>
      </span>
    </div>
  );
}
